(() => {
  const messageSelector = '[data-paypal-message]';

  const getRenderTarget = (message) => {
    if (message.id && window.CSS?.escape) {
      return `#${CSS.escape(message.id)}`;
    }

    return message;
  };

  const getMessageConfig = (message) => {
    const style = {};

    if (message.dataset.ppStyleLayout) {
      style.layout = message.dataset.ppStyleLayout;
    }

    if (message.dataset.ppStyleLogoType) {
      style.logo = {
        type: message.dataset.ppStyleLogoType,
      };
    }

    if (message.dataset.ppStyleTextColor) {
      style.text = {
        color: message.dataset.ppStyleTextColor,
      };
    }

    if (message.dataset.ppStyleTextAlign) {
      style.text = {
        ...style.text,
        align: message.dataset.ppStyleTextAlign,
      };
    }

    const textSize = Number(message.dataset.ppStyleTextSize);
    if (Number.isFinite(textSize) && textSize > 0) {
      style.text = {
        ...style.text,
        size: textSize,
      };
    }

    return {
      amount: message.dataset.ppAmount,
      style,
    };
  };

  const renderMessages = (root = document, { includeCart = false } = {}) => {
    if (!window.PayPalSDK?.Messages) return;

    const messages = root.matches?.(messageSelector)
      ? [root]
      : Array.from(root.querySelectorAll(messageSelector));

    messages.forEach((message) => {
      // Il messaggio del drawer si renderizza solo da renderCartMessage, a drawer aperto.
      if (!includeCart && message.hasAttribute('data-pp-cart-message')) return;
      if (message.dataset.ppRendered === 'true' || message.querySelector('iframe')) return;

      message.dataset.ppRendered = 'true';

      try {
        const rendering = window.PayPalSDK.Messages(getMessageConfig(message)).render(getRenderTarget(message));
        // Il drawer puo riscrivere il DOM mentre l'SDK lavora: evita rejection non gestite.
        rendering?.catch?.(() => {
          message.dataset.ppRendered = 'false';
        });
      } catch (error) {
        message.dataset.ppRendered = 'false';
        console.warn('Unable to render PayPal message', error);
      }
    });
  };

  let cartMessageTimer = null;
  let pendingCartData = null;

  const renderCartMessageNow = () => {
    cartMessageTimer = null;
    const cartData = pendingCartData;
    pendingCartData = null;

    const cartMessage = document.querySelector('[data-pp-cart-message]');
    if (!cartMessage || !cartMessage.isConnected) return;

    // Drawer chiuso: il contenitore e nascosto e puo essere riscritto da un momento all'altro.
    const cartDrawer = cartMessage.closest('cart-drawer');
    if (cartDrawer && !cartDrawer.classList.contains('active')) return;

    const previousAmount = cartMessage.dataset.ppAmount;
    if (cartData?.total_price != null) {
      cartMessage.dataset.ppAmount = (cartData.total_price / 100).toFixed(2);
    }

    // Stesso importo e messaggio gia presente: evita di distruggere un render PayPal in corso.
    const alreadyRendered = cartMessage.dataset.ppRendered === 'true' || cartMessage.querySelector('iframe');
    if (alreadyRendered && previousAmount === cartMessage.dataset.ppAmount) return;

    cartMessage.dataset.ppRendered = 'false';
    cartMessage.replaceChildren();
    renderMessages(cartMessage, { includeCart: true });
  };

  // Drawer, cartUpdate e apertura chiamano questa funzione quasi insieme: un solo render per volta.
  const renderCartMessage = (cartData) => {
    if (cartData) pendingCartData = cartData;
    window.clearTimeout(cartMessageTimer);
    cartMessageTimer = window.setTimeout(renderCartMessageNow, 150);
  };

  window.renderPayPalMessages = renderMessages;
  window.renderPayPalCartMessage = renderCartMessage;

  document.addEventListener('DOMContentLoaded', () => {
    renderMessages();

    if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;

    subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
      const message = document.getElementById(`paypal-pay-later-message-${data.sectionId}`);
      if (!message || data.variant?.price == null) return;

      message.dataset.ppAmount = (data.variant.price / 100).toFixed(2);
      message.dataset.ppRendered = 'false';
      message.replaceChildren();
      renderMessages(message);
    });

    subscribe(PUB_SUB_EVENTS.cartUpdate, ({ cartData }) => {
      renderCartMessage(cartData);
    });
  });

  document.addEventListener('shopify:section:load', (event) => renderMessages(event.target));
})();
